import { useMemo } from 'react';
import { getTenant } from '../../../../../../../configuration/login/loginSlice';
import { useAppDispatch, useAppSelector } from '../../../../../../../configuration/setup/hooks';
import { getShowUserCreation } from '../../../../../../Drivers.selectors';
import {
    changeEmail,
    changeFirstName,
    changeLastName,
    changeNewIdentification,
    changePhoneNumber,
    getFormErrorsRtk,
    getNewIdentificationValueRtk,
    getPendingIdentificationDeletionsRtk,
    getSelectedDriverRtk,
    getShowIdentificationCreationRtk,
    isFetchDriverInProgressRtk,
    setShowNotificationCreation,
    togglePendingIdentificationDeletion,
} from '../../../sidebarSlice';
import type {
    DriverInfoFormPropertiesFromDispatch,
    DriverInfoFormPropertiesFromState,
} from '../../types/driverInfoFormTypes';
import { DriverInfoForm } from '../components/DriverInfoForm';
import { getDriversRtk } from '../../../../../appSlice';
import { setTagsToRemoveThunk } from '../../../../../../crossSliceThunks';

export const DriverInfoFormContainer = () => {
    const dispatch = useAppDispatch();
    const stateProps: DriverInfoFormPropertiesFromState = {
        fetchDriverInProgress: useAppSelector(isFetchDriverInProgressRtk),
        formErrors: useAppSelector(getFormErrorsRtk),
        selectedDriver: useAppSelector(getSelectedDriverRtk),
        pendingDeletions: useAppSelector(getPendingIdentificationDeletionsRtk),
        newIdentificationValue: useAppSelector(getNewIdentificationValueRtk),
        showIdentificationCreation: useAppSelector(getShowIdentificationCreationRtk),
        showUserCreation: useAppSelector(getShowUserCreation),
        tenant: useAppSelector(getTenant),
        existingDrivers: useAppSelector(getDriversRtk),
    };
    const dispatchProps = useMemo<DriverInfoFormPropertiesFromDispatch>(
        () => ({
            changeFirstName: firstName => dispatch(changeFirstName(firstName)),
            changeLastName: lastName => dispatch(changeLastName(lastName)),
            changePhoneNumber: phoneNumber => dispatch(changePhoneNumber(phoneNumber)),
            changeEmail: email => dispatch(changeEmail(email)),
            togglePendingDeletion: identificationId => dispatch(togglePendingIdentificationDeletion(identificationId)),
            changeNewIdentificationValue: identificationValue => dispatch(changeNewIdentification(identificationValue)),
            removeTag: tags => dispatch(setTagsToRemoveThunk(tags)),
            setShowNotificationCreation: show => dispatch(setShowNotificationCreation(show)),
        }),
        [dispatch]
    );

    return <DriverInfoForm {...stateProps} {...dispatchProps} />;
};
